// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import getColor from "@insite/mobius/utilities/getColor";
import { TextFieldProps } from "@tps/MobiusOverrides/TextField/TextField";
import { color, mergeWithCss, modalButtonsActionStyles, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

createUserModalStyles.roleSelectHelpIcon = {
    src: HelpCircle,
    size: 16,
    css: css`
        margin-left: 5px;
        margin-right: 5px;
        cursor: pointer;
        vertical-align: middle;
        position: absolute;
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};

createUserModalStyles.settingsHeadingGridItem = {
    width: 12,
    css: css`
        position: relative;
        padding-block: 14px;
        &&& {
            margin-bottom: 8px;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: calc(100% - 15px);
            height: 1px;
            background-color: ${getColor("common.border")};
            margin: 0 auto;
        }
    `,
};

createUserModalStyles.settingsHeadingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

createUserModalStyles.userNameTextField = {
    placeholder: translate("Username"),
} as TextFieldProps;

createUserModalStyles.emailTextField = {
    placeholder: translate("Email"),
} as TextFieldProps;

createUserModalStyles.firstNameTextField = {
    placeholder: translate("First Name"),
} as TextFieldProps;

createUserModalStyles.lastNameTextField = {
    placeholder: translate("Last Name"),
} as TextFieldProps;

createUserModalStyles.buttonsGridItem = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            &::before {
                width: calc(100% - 15px);
            }
        `,
    }),
};

createUserModalStyles.userNameVisibleGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.emailGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.firstNameGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.lastNameGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.roleGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.approverGridItem = { width: [12, 6, 6, 6, 6] };

createUserModalStyles.approverSelectTooltip = {
    iconProps: {
        color: "common.ui14",
        css: css`
            position: absolute;
            &:hover {
                color: ${color("common.ui8")};
            }
        `,
    },
};
